export const FormEditorTestIds = {
  BLOCKED_NOTICE: 'form-editor.blocked-notice',
};
